<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const goBack = () => {
  // A caller-provided destination is authoritative. Conversation views use
  // this to return to the exact inbox, task or control-panel list that opened
  // them; browser history can contain a stale conversation after a reload.
  if (props.backUrl !== '') {
    router.push(props.backUrl);
    return;
  }

  const accountPathMatch = window.location.pathname.match(
    /^\/app\/accounts\/[^/]+\//
  );
  const previousPath = window.history.state?.back;
  if (
    accountPathMatch &&
    typeof previousPath === 'string' &&
    previousPath.startsWith(accountPathMatch[0])
  ) {
    router.go(-1);
    return;
  }
  router.go(-1);
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
</script>

<template>
  <button
    class="flex items-center p-0 font-normal cursor-pointer text-n-slate-11"
    :class="buttonStyleClass"
    @click.capture="goBack"
  >
    <i class="i-lucide-chevron-left -ml-1 text-lg" />
    {{ buttonLabel || $t('GENERAL_SETTINGS.BACK') }}
  </button>
</template>
